import { render, staticRenderFns } from "./ViewRewards.vue?vue&type=template&id=9b3b77f2&scoped=true"
import script from "./ViewRewards.vue?vue&type=script&lang=js"
export * from "./ViewRewards.vue?vue&type=script&lang=js"
import style0 from "./ViewRewards.vue?vue&type=style&index=0&id=9b3b77f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3b77f2",
  null
  
)

export default component.exports